<template>
  <div class="container_box details_box_styles">
    <div class="opts_box" v-if="viewMode && operationType !== 'look'">
      <Button type="primary" @click="verificationAttribute" v-if="getPermission('ymsProductCategory_insert') ||
        getPermission('ymsProductCategory_update')">{{ $t('key1000555') }}
      </Button>
      <Button style="margin-left: 20px;" @click="resetBtn">{{ $t('key1000112') }}</Button>
    </div>
    <!--树状分类模块-->
    <div class="tree_box">
      <div class="site_box">
        <span>{{ $t('key1000665') }}</span>
        <Select v-model="ymsSiteId" transfer filterable class="width_276" @on-change="changeClassificationSite">
          <Option v-for="item in ymsSiteList" :key="item.ymsSiteId" :value="item.ymsSiteId">{{ item.siteName }}</Option>
        </Select>
      </div>
      <div class="tree_conter" ref="treeScrollBox">
        <div class="all_style">
          <span style="flex-shrink: 0;padding-right: 10px;" @click="exchangeTree">{{ showTree ? $t('key1000794') : $t('key1000795') }}</span>
          <Input v-model.trim="searchTree" :placeholder="$t('key1003516')" @on-change="changeTreeData" @on-enter="enterChange" clearable/>
        </div>
        <!--阿里国际分销类目-->
        <template v-if="isAlibabaSite">
          <Tree
            :load-data="loadCategoryData"
            style="padding: 0 15px 15px 15px;min-height: 650px;"
            :data="categoryTree"
            @on-select-change="onTreeSelectChange"
            @on-toggle-expand="changeExpand">
          </Tree>
        </template>
        <!--云卖类目-->
        <template v-else>
          <Tree
            style="padding: 0 15px 15px 15px;min-height: 650px;"
            :data="categoryTree"
            @on-select-change="onTreeSelectChange"
            @on-toggle-expand="changeExpand">
          </Tree>
        </template>
      </div>
      <div class="category_opts_box">
        <div class="flex_1">
          <Button class="cattegory_btn_style"
            :disabled="(!viewMode || operationType !=='look') && getPermission('ymsProductCategory_update')"
            type="primary"
            @click="editBtn">
            <div class="edit_box">
              <span class="iconfont">&#xe67a;</span>
              <span class="text_style">{{ $t('key1000985') }}</span>
            </div>
          </Button>
        </div>
        <span class="line_styles"></span>
        <div class="flex_1">
          <Button class="cattegory_btn_style"
            :disabled="((!viewMode || operationType !=='look') && addClassificationTalg) || selectedNode.level >=3"
            type="primary"
            @click="addSubcategoryBtn">
            <div class="add_box">
              <span class="iconfont">&#xec5c;</span>
              <span class="text_style">{{ $t('key1003524') }}</span>
            </div>
          </Button>
        </div>
        <span class="line_styles"></span>
        <div class="flex_1">
          <Upload
            :headers="headObj"
            ref="uploadRef"
            name='excleFile'
            :show-upload-list="false"
            :data="uploadData"
            :action="uploadAction"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :on-format-error="handleFormatError"
            :max-size="uploadFilesMaxSize"
            :format="['xls', 'xlsx']">
            <Button class="cattegory_btn_style" type="primary">
              <div class="add_box">
                <span class="iconfont">&#xe664;</span>
                <span class="text_style">{{ $t('key1003525') }}</span>
              </div>
            </Button>
          </Upload>
        </div>
      </div>
    </div>
    <div class="platform_content">
      <Form ref="productCategory" :model="productCategory" :label-width="labelWidth" :rules="rules"
        :disabled="operationType === 'look'" @submit.native.prevent>
        <!--分类信息-->
        <div class="basic_information_box">
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1003526') }}</h2>
            </template>
            <Row type="flex" :gutter="gutterItem">
              <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol" v-show="operationType !== 'add'">
                <Form-item :label="$t('key1003517')" prop="productCategoryCode" :label-width="90">
                  <div class="flex align-items-center">
                    <Input disabled class="width_180" v-model.trim="productCategory.productCategoryCode"></Input>
                    <div class="flex align-items-center ml50">
                      <span>{{ $t('key1003527') }}</span>
                      <RadioGroup v-model="productCategory.isShow">
                        <Radio :label="1" :disabled="displayConfiguration">{{ $t('key1002383') }}</Radio>
                        <Radio :label="0" :disabled="displayConfiguration">{{ $t('key1003528') }}</Radio>
                      </RadioGroup>
                      <Tooltip v-if="displayConfiguration" max-width="350" placement="top" class="cursor" transfer
                        :content="$t('key1003518')">
                        <Icon size="18" type="md-help-circle"/>
                      </Tooltip>
                    </div>
                  </div>
                </Form-item>
              </Col>
              <languagesTabs :tabsList="multilingualNamesList">
                <template v-for="item in multilingualNamesList">
                  <template :slot="item.name">
                    <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
                      <Form-item :label="labelRander(item)" :prop="'name_' + item.code" :rules="getRules(item)" :label-width="190">
                        <Input clearable v-model.trim="productCategory['name_' + item.code]"></Input>
                      </Form-item>
                    </Col>
                  </template>
                </template>
              </languagesTabs>
            </Row>
          </Card>
        </div>
        <!--平台信息-->
        <div class="basic_information_box pos-rel">
          <Card :bordered="false" dis-hover>
            <template #title>
              <div class="flex justify-content-between align-items">
                <h2 class="title_box">{{ $t('key1003529') }}</h2>
                <Button type="primary" @click="$refs.platformModal.open('add',{
                  specData: commoditySpecificationsData,
                  attrData: tableData
                })">{{ $t('key1003368') }}
                </Button>
              </div>
            </template>
            <div class="platform_box">
              <Table
                max-height="400"
                border
                :columns="platformColumns"
                :data="platformData">
              </Table>
            </div>
          </Card>
        </div>
        <!--报关信息-->
        <div class="basic_information_box">
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1003530') }}</h2>
            </template>
            <Row type="flex" :gutter="gutterItem">
              <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="threeItemCol" :md="threeItemCol">
                <Form-item :label="$t('key1003519')" prop="hsCode">
                  <Input v-model.trim="productCategory.hsCode"></Input>
                </Form-item>
              </Col>
              <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="threeItemCol" :md="threeItemCol">
                <Form-item :label="$t('key1003520')" prop="cnHsName">
                  <Input v-model.trim="productCategory.cnHsName"></Input>
                </Form-item>
              </Col>
              <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="threeItemCol" :md="threeItemCol">
                <Form-item :label="$t('key1003521')" prop="enHsName">
                  <Input v-model.trim="productCategory.enHsName"></Input>
                </Form-item>
              </Col>
            </Row>
          </Card>
        </div>
        <!--商品规格-->
        <div class="basic_information_box">
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1000721') }}</h2>
            </template>
            <div class="table_box">
              <div class="options_box mb20">
                <Button
                  type="primary"
                  class="mr15"
                  @click="$refs['attributePool'].initAttributePoolData(1, ymsSiteId)"
                  :disabled="operationType === 'look'">
                  {{ $t('key1000406') }}
                </Button>
                <Button
                  type="primary"
                  @click="addAttributesBtn('specifications')"
                  :disabled="operationType === 'look' || !getPermission('ymsProductAttributeTemplate_insert')">
                  {{ $t('key1000428') }}
                </Button>
              </div>
              <Table
                max-height="350"
                border
                :loading="tableLoading"
                :columns="commoditySpecificationsColumns"
                :data="commoditySpecificationsData">
              </Table>
            </div>
          </Card>
        </div>
        <!--商品定制部位-->
        <div class="basic_information_box">
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1003531') }}</h2>
            </template>
            <div class="table_box">
              <div class="flex align-items-center mb8">
                <span>{{ $t('key1003532') }}</span>
                <RadioGroup v-model="isSupportCustomization" class="customizedParts_set_box">
                  <Radio :label="0" class="mr25">{{ $t('key1000393') }}</Radio>
                  <span class="customizedParts_set_item customizedParts_deny" @click.stop="customizedPartsChange(0)"></span>
                  <Radio :label="1">{{ $t('key1000392') }}</Radio>
                  <span class="customizedParts_set_item customizedParts_correct" @click.stop="customizedPartsChange(1)"></span>
                </RadioGroup>
              </div>
              <template v-if="isSupportCustomization">
                <div class="options_box mb20">
                  <Button
                    type="primary"
                    @click="$refs['customizedParts'].initCustomizedPartsData('add')"
                    :disabled="operationType === 'look' || !getPermission('ymsProductAttributeTemplate_insert')">
                    {{ $t('key1003533') }}
                  </Button>
                </div>
                <Table
                  max-height="350"
                  border
                  :loading="tableLoading"
                  :columns="customizedPartsColumns"
                  :data="customizedPartsData">
                  <template #locationStatus="{row, index}">
                    <i-switch v-model="customizedPartsData[index].status" :true-value="1" :false-value="0" size="large">
                      <span slot="open" class="font-size-12">{{ $t('key1000462') }}</span>
                      <span slot="close" class="font-size-12">{{ $t('key1000463') }}</span>
                    </i-switch>
                  </template>
                </Table>
              </template>
            </div>
          </Card>
        </div>
        <!--尺码表(商品规格包含有尺码属性才显示尺码表)-->
        <div class="basic_information_box" v-if="isSizeAttribute">
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1000978') }}</h2>
            </template>
            <Row type="flex" :gutter="gutterItem">
              <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="threeItemCol" :md="threeItemCol">
                <Form-item :label="$t('key1003522')" prop="ymsProductSizeTemplateId">
                  <Select v-model.trim="productCategory.ymsProductSizeTemplateId" transfer :placeholder="$t('key1000101')" filterable>
                    <Option v-for="(item, index) in ymsProductSizeValueList" :value="item.ymsProductSizeTemplateId" :key="index">{{ item.name }}</Option>
                  </Select>
                </Form-item>
              </Col>
            </Row>
          </Card>
        </div>
        <!--商品属性-->
        <div class="basic_information_box">
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1000940') }}</h2>
            </template>
            <div class="table_box">
              <div class="options_box mb20">
                <Button
                  type="primary"
                  class="mr15"
                  @click="$refs['attributePool'].initAttributePoolData(0, ymsSiteId)"
                  :disabled="operationType === 'look'">
                  {{ $t('key1000406') }}
                </Button>
                <Button
                  type="primary"
                  @click="addAttributesBtn('attribute')"
                  :disabled="operationType === 'look' || !getPermission('ymsProductAttributeTemplate_insert')">
                  {{ $t('key1000428') }}
                </Button>
              </div>
              <Table
                max-height="350"
                border
                :loading="tableLoading"
                :columns="commodityAttributeColumns"
                :data="tableData">
              </Table>
            </div>
          </Card>
        </div>
      </Form>
    </div>
    <!--新增属性弹窗-->
    <addAttributes ref="attrModal" attributeTalg="associationProperty" :ymsSiteList="ymsSiteList" @updateData="updateData"></addAttributes>
    <!--属性池管理弹窗-->
    <attributePoolModal
      ref="attributePool"
      :attributeTableData="tableData"
      :specificationsTableData="commoditySpecificationsData"
      @updateAttributeTableData="updateAttributeTableData"
      @updateSpecificationsTableData="updateSpecificationsTableData">
    </attributePoolModal>
    <!--选择类目的层级弹窗-->
    <choseCategory
      ref="choseCategoryTalg"
      :siteId="siteId"
      :platformId="categoryPlatformId"
      :currentIndex="currentIndex"
      @save="categorySave">
    </choseCategory>
    <!--属性映射-->
    <!--    <mappingAttr ref="mappingAttrRef" @getDetails="onGetDetails" :attrData="tableData"></mappingAttr>-->
    <platform-modal
      ref="platformModal"
      @success="platformMapping"
      :ymsProductCategoryId="productCategory.ymsProductCategoryId">
    </platform-modal>
    <!--商品定制部位弹窗-->
    <customizedPartsModal ref="customizedParts" @updateCustomizedParts="updateCustomizedParts"></customizedPartsModal>
    <!--编辑失败提示-->
    <Modal v-model="editingFailurePromptModal" :title="$t('key1003523')" class-name="commonModalStyles"
      width="700" :transfer="false" :mask-closable="false">
      <p>
        <span>{{ $t('key1003534') }}</span>
        <span class="themeColor ml4 mr4">{{ errorMessageContentList.join('、') }}</span>
        <span>{{ $t('key1003535') }}</span>
      </p>
      <p class="themeColor">{{ $t('key1003536') }}</p>
      <template #footer>
        <Button @click="editingFailurePromptModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="attributeBtn(0)">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import addAttributes from "@/components/common/addAttributes";
import choseCategory from "@/components/common/choseCategory";
import mappingAttr from '@/views/yms/components/commodityManage/mappingAttr';
import PlatformModal from '@/views/yms/components/commodityManage/platformModal';
import languagesTabs from "@/components/common/languagesTabs.vue";
import attributePoolModal from "@/views/yms/components/commodityManage/attributePoolModal";
import customizedPartsModal from "@/views/yms/components/commodityManage/customizedPartsModal.vue";
import {
  _handleMultilingualFields, getAllUsersInfo, getDataSetBatchList, getEnumName, getUserNameByUserId, getYmsSiteData, isJSON,
  pageJump, sortCategory, verifyCategoryCustomizedProducts
} from "@/utils/common";

export default {
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      latelyTree: [],
      rules: {
        /*name: [
          {required: true, validator: cnameValidator, trigger: 'blur'}
        ],*/
        hsCode: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003498'), trigger: 'blur'}
        ],
        cnHsName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003499'), trigger: 'blur'}
        ],
        enHsName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003500'), trigger: 'blur'}
        ],
        ymsProductSizeTemplateId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003501'), trigger: 'change'}
        ],
      },
      categoryPlatformId: '',
      operationType: 'add',
      showTree: true,
      selectedNode: [],
      currentIndex: 0,
      viewMode: false, // 是否查看模式
      addClassificationTalg: false,
      selectedProductCategory: null, // 当前选中的分类
      platformId: null, // 平台的id
      siteId: null, // 站点id
      productCategory: { // 分类表单模型
        isShow: 1,
        productCategoryCode: null,
        parentId: null,
        ymsProductCategoryId: null,
        ymsProductSizeTemplateId: null, // 尺码表模板id
        hsCode: '',
        cnHsName: '',
        enHsName: ''
      },
      platformList: [
        {
          platformId: null,
          siteId: null,
          categoryName: '',
          categoryId: null,
          showTalg: true
        }
      ],
      categoryTree: [ // 分类树
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000369'),
          expand: true,
          selected: false,
          ymsProductCategoryId: '-1',
          render(h, {root, node, data}) {
            return h('span', {
              class: 'hover-color-ccc'
            }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000369'));
          },
          children: []
        }
      ],
      nameToObject: {},
      platformColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001793'),
          key: 'platformName',
          render(h, params) {
            let platformName = '-';
            let extendJson = params.row.extendJson;
            if (extendJson) {
              if (isJSON(extendJson)) {
                let obj = JSON.parse(extendJson);
                platformName = obj.platformName || '-';
              }
            } else {
              platformName = params.row.platformName || '-';
            }
            return h('span', platformName);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003502'),
          key: 'siteName',
          render(h, params) {
            let siteName = '-';
            let extendJson = params.row.extendJson;
            if (extendJson) {
              if (isJSON(extendJson)) {
                let obj = JSON.parse(extendJson);
                siteName = obj.siteName || '-';
              }
            } else {
              siteName = params.row.siteName || '-';
            }
            return h('span', siteName);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003303'),
          key: 'category',
          render(h, params) {
            let obj;
            let name = '-';
            if (params.row.categoryTree) {
              if (v.typeOf(params.row.categoryTree) === 'array') {
                if (params.row.platformId === 'walmart') {
                  obj = params.row.categoryTree;
                  name = obj.map(i => i.categoryName).join('>');
                } else {
                  obj = params.row.categoryTree;
                  name = obj.map(i => i.categoryId + '-' + i.categoryName).join('>');
                }

              }
            }
            return h('span', name);
          }
        },
        {
          title: 'Product Type',
          key: 'platform',
          render(h, params) {
            let productType = '-';
            let extendJson = params.row.extendJson;
            if (extendJson) {
              if (isJSON(extendJson)) {
                let obj = JSON.parse(extendJson);
                productType = obj.productType || '-';
              }
            } else {
              let amazonCategoryParamBo = params.row.amazonCategoryParamBo || null;
              if (amazonCategoryParamBo) {
                productType = amazonCategoryParamBo.productType || '-';
              }
            }
            return h('span', productType);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          width: 100,
          render: (h, params) => {
            let status = params.row.status;
            let text = status === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463');
            return h('span', {class: status === 1 ? 'openStatus' : 'stopStatus'}, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'operation',
          width: 150,
          render(h, params) {
            let ymsListingCategoryMappingId = params.row.ymsListingCategoryMappingId;
            let status = params.row.status;
            let text = status === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462');
            let title = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003494')}${text}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003495')}`;
            let showStatus = params.row.showStatus || false;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.operationType === 'look',
                    clickFn: () => {
                      v.$refs['platformModal'].open('look', {
                        specData: v.commoditySpecificationsData,
                        attrData: v.tableData,
                        index: params.index,
                        row: JSON.parse(JSON.stringify(params.row))
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003503'),
                    show: v.operationType === 'edit',
                    clickFn: () => {
                      v.$refs.platformModal.open('edit', {
                        specData: v.commoditySpecificationsData,
                        attrData: v.tableData,
                        index: params.index,
                        row: JSON.parse(JSON.stringify(params.row))
                      });
                    }
                  },
                  {
                    show: v.operationType === 'edit' && (v.getPermission('ymsListingCategoryMapping_disable')
                      || v.getPermission('ymsListingCategoryMapping_enable')) && showStatus,
                    customRender: true, // 开启自定义内容的render函数
                    renderCustomContent: (h) => {
                      return h('Poptip', {
                        props: {
                          title: title,
                          transfer: false,
                          confirm: true,
                          placement: 'top-end'
                        },
                        class: 'reset_tooltip_style',
                        on: {
                          'on-ok'() {
                            v.enableDeactivateBtn(status, ymsListingCategoryMappingId);
                          }
                        }
                      }, [
                        h('span', {class: status === 1 ? 'stopStatus pt2 pb2 pl6 pr6 cursor' : 'openStatus pt2 pb2 pl6 pr6 cursor'}, text)
                      ]);
                    }
                  },
                  {
                    show: v.operationType === 'edit',
                    customRender: true, // 开启自定义内容的render函数
                    renderCustomContent: (h) => {
                      return h('Poptip', {
                        props: {
                          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003497'),
                          transfer: true,
                          confirm: true,
                          placement: 'top-end'
                        },
                        class: 'reset_tooltip_style',
                        on: {
                          'on-ok'() {
                            v.platformData.splice(params.index, 1);
                          }
                        }
                      }, [h('span', {class: 'pt2 pb2 pl6 pr6 cursor deleteColor'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'))]);
                    }
                  }
                ]
              },
              on: { // 动态设置操作的宽度
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      platformData: [], // 平台名称数据
      siteData: [], // 站点名称数据
      commodityAttributeColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000396'),
          minWidth: 100,
          key: 'cnName',
          align: 'center',
          render(h, params) {
            let text = params.row.status === 0 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002631') : '';
            let name = params.row.cnName;
            return h('div', [
              h('span', name),
              h('span', {class: 'redColor ml5'}, text)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000397'),
          key: 'type',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let type = params.row.type;
            let text = getEnumName(v.enumData, 'YmsProductAttributeValueTypeCoreEnum', type);
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000399'),
          key: 'attributeRequire',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let typeArr = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000304'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000305'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000306')];
            let txt = typeArr[params.row.attributeRequire];
            return h('span', txt);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003422'),
          key: 'attributeRequire',
          align: 'center',
          width: 230,
          render(h, params) {
            const typeArr = [{value: '1', label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003423')}, {value: '2', label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000304')}, {value: '3', label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003424')}];
            return h('div', [
              h('Select', {
                props: {
                  value: params.row.keyWordsType,
                  transfer: true,
                  disabled: v.operationType === 'look'
                },
                on: {
                  'on-change'(e) {
                    params.row.keyWordsType = e;
                    v.tableData[params.index] = params.row;
                  }
                },
                style: {
                  width: '150px'
                }
              }, typeArr.map(i => h('Option', {
                props: {
                  value: i.value,
                  label: i.label
                }
              })
              )),
              v.operationType !== 'look' ? h('Poptip', {
                props: {
                  confirm: true,
                  transfer: true,
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003504')
                },
                on: {
                  'on-ok'() {
                    v.editGenerateListingBatch(params.row);
                  }
                }
              }, [
                h('Icon', {
                  props: {
                    type: 'ios-sync',
                    size: '24'
                  },
                  attrs: {
                    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003505')
                  },
                  class: 'table-icon',
                  on: {
                    'click'() {

                    }
                  },
                  style: {
                    marginLeft: '5px',
                    color: 'blue',
                    verticalAlign: 'middle',
                    cursor: 'pointer'
                  }
                })
              ]) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 180,
          render(h, params) {
            let ymsProductAttributeTemplateId = params.row.ymsProductAttributeTemplateId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.getPermission('ymsProductAttributeTemplate_detail'),
                    clickFn: () => {
                      v.$refs['attrModal'].initAttributesData('look', ymsProductAttributeTemplateId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.operationType !== 'look',
                    clickFn: () => {
                      if (v.operationType === 'edit') {
                        v.isDeleteItemAttribute = true;
                      }
                      v.tableData.splice(params.index, 1);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ], // 商品属性
      tableData: [],
      commoditySpecificationsData: [],
      handlerClassifiedData: [],
      classifiedList: [],
      searchTree: '',
      originTreeData: [], // 树
      dragConfig: {
        isStartExpandCache: false,
        isEndExpandCache: false,
        startTarget: {},
        endTarget: {}
      },
      ymsProductSizeValueList: [],
      isSizeAttribute: false, // 商品规格列表中是否包含尺码属性
      fieldList: ['cnName', 'productCategoryCode', 'cnHsName', 'enHsName', 'hsCode', 'ymsProductSizeTemplateId'], // 表单字段
      originalSpecificationsList: [],
      productCountData: [],
      timer: null,
      isDeleteItemAttribute: false, // 记录是否操作移除商品属性
      labelRander: (params) => {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003442') + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424');
      },
      totalProductQuantityStatistics: 0, // 总的商品数量统计
      ymsSiteList: [],
      ymsSiteId: null, // 分类站点id
      merchantType: '',
      uploadAction: api.post_ymsProductCategory_excelImport,
      uploadData: {},
      categoryDetailsData: null,
      customizedPartsColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003506'),
          key: 'customizedPartName',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let parts = params.row.parts;
            let name = _handleMultilingualFields(parts);
            return h('span', name);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'),
          key: 'createdBy',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'locationStatus',
          align: 'center',
          minWidth: 130,
          slot: 'locationStatus'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          width: 100,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                align: 'center',
                operationList: [
                  {
                    text: v.operationType === 'look' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: true,
                    clickFn: () => {
                      v.$refs['customizedParts'].initCustomizedPartsData('edit', params.row, params.index);
                    }
                  }
                ]
              }
            });
          }
        }
      ],
      customizedPartsData: [],
      isSupportCustomization: 0,
      errorMessageContentList: [],
      editingFailurePromptModal: false,
      updateCategoryTalg: true,
      updateDetailsTalg: true,
      isInternalTreeSelect: false,
      pendingClassifyDetailId: null,
      commoditySpecificationsColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000396'),
          minWidth: 100,
          key: 'cnName',
          align: 'center',
          render(h, params) {
            let text = params.row.status === 0 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002631') : '';
            let name = params.row.cnName;
            return h('div', [
              h('span', name),
              h('span', {class: 'redColor ml5'}, text)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000397'),
          key: 'type',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let type = params.row.type;
            let text = getEnumName(v.enumData, 'YmsProductAttributeValueTypeCoreEnum', type);
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000399'),
          key: 'attributeRequire',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let typeArr = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000304'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000305'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000306')];
            let txt = typeArr[params.row.attributeRequire];
            return h('span', txt);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003259'),
          key: 'isSizeAttribute',
          width: 160,
          align: 'center',
          render(h, params) {
            let text = params.row.isSizeAttribute ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003507'),
          key: 'attributeSettings',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            let isMainAttribute = params.row.isMainAttribute === 1;
            let talg = false;
            let newList = v.originalSpecificationsList;
            if (newList.length > 0) {
              talg = newList.some(item => item.isMainAttribute === 1);
            }
            return isMainAttribute ? h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003508')) : h('Alink', {
              props: {
                linkName: !talg ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003509') : '',
                AlinkShow: v.operationType !== 'look' && !talg
              },
              on: {
                AlinkBtn: () => {
                  v.setMainAttr(params.row);
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 180,
          render(h, params) {
            let isMainAttribute = params.row.isMainAttribute !== 1;
            let ymsProductAttributeTemplateId = params.row.ymsProductAttributeTemplateId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: true,
                    clickFn: () => {
                      v.$refs['attrModal'].initAttributesData('look', ymsProductAttributeTemplateId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.operationType !== 'look' && isMainAttribute,
                    clickFn: () => {
                      v.commoditySpecificationsData.splice(params.index, 1);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      userInfoList: {},
      enumData: []
    };
  },
  computed: {
    // 判断是否是阿里国际分销站点
    isAlibabaSite() {
      return this.merchantType === 'ALIGJ';
    },
    displayConfiguration() {
      let talg = false;
      if (this.categoryDetailsData) {
        let parentCode = this.categoryDetailsData.parentCode;
        if (this.originTreeData.length > 0) {
          this.originTreeData.map((item) => {
            if (item.productCategoryCode === parentCode) {
              talg = item.isShow === 0;
            }
          });
        }
      }
      return talg;
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    initData(type) {
      let v = this;
      (async () => {
        let enumKeyList = ['YmsProductAttributeValueTypeCoreEnum'];
        v.enumData = await getDataSetBatchList(enumKeyList);
        if (!type) {
          v.ymsSiteId = null;
          v.ymsSiteList = [];
          await getYmsSiteData().then((data) => {
            v.ymsSiteList = data;
            v.ymsSiteId = v.ymsSiteList[0].ymsSiteId;
            v.merchantType = v.ymsSiteList[0].merchantType;
          });
        }
        await getAllUsersInfo().then(data => {
          v.userInfoList = data;
        });
        await v.initMultilingualFields('productCategory', v.productCategory, ['name_']);
        await v.getProductCount().then(() => {
          v.getProductSizeTemplateData();
          v.getList();
        });
      })();
    },
    // 平台映射
    platformMapping({type, data, index}) {
      let _data = JSON.parse(JSON.stringify(data));
      if (type === 'add') {
        this.platformData.push(_data);
      } else {
        this.$set(this.platformData, index, _data);
      }
    },
    // 处理搜索分类的数据
    processSearchClassificationData(data) {
      let v = this;
      if (data.length === 0) {
        v.categoryTree = [];
        return;
      }
      data.forEach(item => {
        item.categoryCount = 0;
        v.productCountData.forEach(ele => {
          if (item.ymsProductCategoryId === ele.ymsProductCategoryId) {
            item.categoryCount = ele.productCount;
          }
        });
      });
      data.forEach(i => {
        let productCategoryNavigation = i.productCategoryNavigation.split('->');
        productCategoryNavigation.splice(-1, 1);
        if (productCategoryNavigation.length > 0) {
          // 拿到相关父级
          let hasNav = productCategoryNavigation.reduce((a, b) => {
            a.push(b);
            return a;
          }, []);
          v.originTreeData.forEach(k => {
            if (i.parentCode === k.productCategoryCode) {
              data.push(k);
            }
            hasNav.forEach(p => {
              if (k.name === p) {
                // 去重
                if (data.every(h => h.name !== p)) {
                  data.push(k);
                }
              }
            });
          });
        }
      });
      let newData = v.uniqueFunc(data, 'ymsProductCategoryId');
      if (newData.length > 0) {
        v.timer = setTimeout(() => {
          for (let i = 0; i < newData.length; i++) {
            let item = newData[i];
            let reg = new RegExp(v.searchTree, 'g');
            if (reg.test(item.name)) {
              item.name = item.name.replace(reg, '<span class="keywords_highlight">$&</span>');
            }
          }
          let obj = v.updateCategoryTalg ? null : v.selectedProductCategory;
          v.setTreeData(v.deepCopy(newData), obj);
          v.updateCategoryTalg = true;
        }, 500);
      }
    },

    // 阿里国际分销回车键搜索分类
    enterChange() {
      let v = this;
      if (v.isAlibabaSite) {
        if (v.searchTree) {
          let query = {
            name: v.searchTree,
            ymsSiteId: v.ymsSiteId
          };
          v.axios.post(api.post_ymsProductCategory_queryCategorysByName, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((response) => {
            if (response.data.code === 0) {
              let data = response.data.datas || [];
              v.processSearchClassificationData(data);
            }
          });
        } else {
          clearTimeout(v.timer);
          v.setTreeData(v.deepCopy(v.originTreeData), null, 'aligjQuery');
        }
      }
    },

    // 搜索关键词
    changeTreeData() {
      let v = this;
      if (v.searchTree) {
        if (!v.isAlibabaSite) {
          let data = v.deepCopy(v.originTreeData).filter(i => i.name.includes(v.searchTree));
          v.processSearchClassificationData(data);
        }
      } else {
        clearTimeout(v.timer);
        let value = v.selectedProductCategory || null;
        v.setTreeData(v.deepCopy(v.originTreeData), value);
      }
    },
    editGenerateListingBatch(row) {
      let v = this;
      let {listing} = row;
      v.tableData.forEach(i => {
        v.$set(i, 'listing', listing);
      });
    },
    // 获取树状分类数据
    getList(selectedProductCategory) {
      let self = this;
      self.categoryTree = [];
      let query = {
        ymsSiteId: self.ymsSiteId
      };
      // 如果是阿里国际分销，默认值获取一级类目，子类目需要手动查询
      if (this.isAlibabaSite) {
        query.type = 'firstLevel';
      }
      if (self.getPermission('ymsProductCategory_queryAll')) {
        this.axios.post(api.post_ymsProductCategory_queryAll, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000514')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              self.originTreeData = self.deepCopy(JSON.parse(JSON.stringify(data)));
              if (self.isAlibabaSite) {
                self.searchTree = '';
              }
              self.setTreeData(data, selectedProductCategory);
            }
          }
        });
      } else {
        self.gotoError();
      }
    },
    setTreeHead() {
      let v = this;
      this.categoryTree = [ // 分类树
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000369'),
          expand: true,
          selected: false,
          ymsProductCategoryId: '-1',
          render(h, {root, node, data}) {
            return h('div', {class: 'flex justify-content-between'}, [
              h('span', {
                class: 'hover-color-ccc'
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000369')),
              h('span', {class: 'mr20'}, `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003496')}${v.totalProductQuantityStatistics}`)
            ]);
          },
          children: []
        }
      ];
    },
    // 获取商品数量
    getProductCount() {
      let v = this;
      v.totalProductQuantityStatistics = 0;
      v.productCountData = [];
      return new Promise(resolve => {
        v.axios.get(api.get_ymsProductCategory_productCount + `?ymsSiteId=${v.ymsSiteId}`).then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas || [];
            v.productCountData = data;
            v.totalProductQuantityStatistics = data.reduce((acc, item) => acc + item.productCount, 0);
            resolve();
          }
        });
      });
    },

    setTreeData(data, selectedProductCategory, type) {
      let self = this;
      data.forEach((item) => {
        item.children = [];
        if (self.isAlibabaSite && type !== 'aligjQuery') {
          item.loading = false;
        }
      });
      data = data.sort(sortCategory);
      self.setTreeHead();
      self.$set(self.categoryTree[0], 'children', []);
      self.categoryTree[0].children = self.toTree(data, 'productCategoryNavigation', '->', selectedProductCategory);
      self.categoryTree[0].selected = false;
      self.categoryTree[0].ymsProductCategoryId = '-1';
      if (data && data.length) {
        if (selectedProductCategory) {
          data.map((item) => {
            if (item.ymsProductCategoryId === selectedProductCategory.ymsProductCategoryId) {
              self.selectedNode = item;
            }
          });
        } else {
          self.selectedNode = data[0];
        }
      }
      data.map(item => {
        item.categoryCount = 0;
        self.productCountData.map(ele => {
          if (item.ymsProductCategoryId === ele.ymsProductCategoryId) {
            item.categoryCount = ele.productCount;
          }
        });
      });
      let treeItem = null;
      if (selectedProductCategory) {
        if (selectedProductCategory.ymsProductCategoryId !== '-1') {
          treeItem = selectedProductCategory;
        } else {
          treeItem = self.handlerClassifiedData[0];
        }
      } else {
        treeItem = self.handlerClassifiedData[0];
      }
      if (self.updateDetailsTalg) {
        self.isInternalTreeSelect = true;
        self.view([treeItem]);
        self.$nextTick(() => {
          self.isInternalTreeSelect = false;
        });
      }
      self.operationType = 'look';
      self.viewMode = true;
      setTimeout(() => {
        self.scrollToSelectedNode();
        self.updateCategoryTalg = true;
      }, 1000);
      self.$forceUpdate();
    },
    // 树节点选中（程序化更新树时跳过，避免重复拉详情）
    onTreeSelectChange(data) {
      if (this.isInternalTreeSelect) {
        return;
      }
      this.view(data);
    },
    // 获取分类的详情的数据
    getClassifyDetails(ymsProductCategoryId) {
      let v = this;
      if (!ymsProductCategoryId) {
        return;
      }
      if (v.pendingClassifyDetailId === ymsProductCategoryId) {
        return;
      }
      v.pendingClassifyDetailId = ymsProductCategoryId;
      v.platformList = [];
      v.platformData = [];
      v.tableData = [];
      v.originalPlatformInfoData = [];
      v.optionBtnWidth = [];
      v.commoditySpecificationsData = [];
      v.originalSpecificationsList = [];
      v.$nextTick(() => {
        v.$refs['productCategory'].resetFields();
      });
      v.axios.get(api.get_ymsProductCategory_ymsProductCategoryId + ymsProductCategoryId, {loading: true}).then(response => {
        v.tableLoading = false;
        if (v.pendingClassifyDetailId !== ymsProductCategoryId) {
          return;
        }
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
              // 分类名称
              let obj = v.handleMultilingualFormFields(data, ['name']);
              v.productCategory.ymsProductCategoryId = data.ymsProductCategoryId;
              // 分类信息、报关信息
              v.fieldList.map((key) => {
                v.productCategory[key] = data[key] || null;
              });
              v.productCategory.isShow = data.isShow;
              // 尺码表模板
              v.productCategory.ymsProductSizeTemplateId = data.ymsProductSizeTemplateResult.ymsProductSizeTemplateId;
              v.productCategory = Object.assign({}, v.productCategory, obj);
              // 平台信息
              let ymsListingCategoryMappingList = data.ymsListingCategoryMappingList || [];
              if (ymsListingCategoryMappingList.length > 0) {
                let newList = ymsListingCategoryMappingList.map(i => {
                  if (i.extendJson) {
                    if (isJSON(i.extendJson)) {
                      let obj = JSON.parse(i.extendJson);
                      i.siteName = obj.siteName || '-';
                      i.platformName = obj.platformName || '-';
                      i.categoryTree = obj.categoryTree || [];
                      i.amazonProductTypeList = obj.amazonProductTypeList || [];
                      i.amazonAttributeList = obj.amazonAttributeList || [];
                      i.amazonAttributeId = obj.amazonAttributeId || null;
                      i.amazonCategoryParamBo = {
                        amazonProductTypeId: obj.amazonProductTypeId,
                        amzonPublishTemplateId: obj.amzonPublishTemplateId,
                        productType: obj.productType,
                        rootCategoryId: obj.rootCategoryId,
                        amazonAttributeId: obj.amazonAttributeId,
                        amazonAttributeList: obj.amazonAttributeList ? JSON.parse(obj.amazonAttributeList) : [],
                        amazonProductTypeList: obj.amazonProductTypeList ? JSON.parse(obj.amazonProductTypeList) : [],
                      };
                      i.emagId = obj.emagId || null;
                    }
                    i.showStatus = true;
                  }
                  i.updateYmsListingCategoryMappingAttributeBos = JSON.parse(JSON.stringify(i.ymsListingCategoryMappingAttributeList));
                  delete i.ymsListingCategoryMappingAttributeList;
                  return i;
                });
                v.platformData = newList.filter((item) => {
                  return item.extendJson !== null;
                });
              }
              // attributeType: 0 基础属性   1 规格属性
              if (data.ymsCategoryProductAttributeBos && data.ymsCategoryProductAttributeBos.length > 0) {
                // 商品规格
                v.originalSpecificationsList = data.ymsCategoryProductAttributeBos.filter(item => item.attributeType === 1);
                v.commoditySpecificationsData = data.ymsCategoryProductAttributeBos.filter(item => item.attributeType === 1);
                // 商品属性
                v.tableData = data.ymsCategoryProductAttributeBos.filter(item => item.attributeType === 0);

                setTimeout(() => {
                  if (v.commoditySpecificationsData.length > 0) {
                    v.commoditySpecificationsData = [...v.commoditySpecificationsData];
                  }
                  if (v.tableData.length > 0) {
                    v.tableData = [...v.tableData];
                  }
                }, 200);
              }
              // 商品定制部位
              v.isSupportCustomization = data.isSupportCustomization || 0;
              v.customizedPartsData = data.ymsProductCategoryPositions || [];
              v.categoryDetailsData = data;
              if (!v.updateCategoryTalg) {
                v.updateDetailsTalg = false;
                setTimeout(() => {
                  v.changeTreeData();
                }, 800);
              }
            }
          }
      }).finally(() => {
        if (v.pendingClassifyDetailId === ymsProductCategoryId) {
          v.pendingClassifyDetailId = null;
        }
      });
    },
    recursionCount(data) {
      let v = this;
      data.forEach(i => {
        if (i.children && i.children.length > 0) {
          i.categoryCount = i.children.reduce((b, j) => {
            return b + j.categoryCount;
          }, 0);
          v.recursionCount(i.children);
        }
      });
    },
    // 处理类目树状结构展示的内容
    toTree(arr, key, Identification, selectedProductCategory, value) {
      let newArr = [];
      let ymsProductCategoryId = null;
      let v = this;
      arr.forEach((i, index) => {
        i.selected = false;
        let matchName; // 最后一个name
        let name = i[key]; // 用来判断的值 =>分割
        if (value !== 'subclass') {
          if (selectedProductCategory) {
            if (selectedProductCategory.ymsProductCategoryId === '-1') {
              if (v.handlerClassifiedData.length > 0) {
                ymsProductCategoryId = v.handlerClassifiedData[0].ymsProductCategoryId;
              }
            } else {
              ymsProductCategoryId = selectedProductCategory.ymsProductCategoryId;
            }
            if (ymsProductCategoryId === i.ymsProductCategoryId) {
              i.selected = true;
            }
          } else {
            arr[0].selected = true;
          }
          if (name.lastIndexOf(Identification) > -1) {
            matchName = name.slice(0, name.lastIndexOf(Identification));
          } else {
            matchName = name;
            newArr.push(i);
          }
          if (v.nameToObject[matchName]) {
            v.nameToObject[matchName].children.push(i);
          }
          v.nameToObject[name] = i;
          v.nameToObject[name].children = [];
        } else {
          newArr.push(i);
        }
        if (!i.categoryCount) {
          i.categoryCount = 0;
        } else {
          if (i.children && i.children.length > 0) {
            i.categoryCount = i.children.reduce((a, b) => {
              return b.categoryCount + a;
            }, 0);
          } else {
            i.categoryCount = i.categoryCount;
          }
        }
        i.render = (h, {root, node, data}) => {
          // 操作按钮
          let options = h('div', {
            style: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              width: '80px',
            },
          },
          [
              // 升序
              v.getPermission('ymsProductCategory_sort') ? h('Icon', {
                props: {
                  type: 'md-arrow-up'
                },
                style: {
                  display: data.ascTalg ? 'inline-block' : 'none'
                },
                class: 'option_icon_style arrow-up',
                on: {
                  'click'(e) {
                    e.stopPropagation();
                    v.classificationSort(data, 'asc');
                  }
                }
              }) : '',
              // 降序
              v.getPermission('ymsProductCategory_sort') ? h('Icon', {
                props: {
                  type: 'md-arrow-down'
                },
                style: {
                  display: data.descTalg ? 'inline-block' : 'none'
                },
                class: 'option_icon_style arrow-down',
                on: {
                  'click'(e) {
                    e.stopPropagation();
                    v.classificationSort(data, 'desc');
                  }
                }
              }) : '',
              // 删除
              v.getPermission('ymsProductCategory_delete') ? h('Icon', {
                props: {
                  type: 'ios-trash-outline'
                },
                style: {
                  fontSize: '22px',
                  marginLeft: '6px',
                  cursor: 'pointer'
                },
                on: {
                  'click'(e) {
                    e.stopPropagation();
                    v.deleteClassification(data.ymsProductCategoryId);
                  }
                }
              }) : ''
          ]);
          let ordinary = h('div', {
            style: {
              display: 'flex',
              alignItems: 'center',
              flex: '1'
            }
          },
          [
            h('span', {
              style: {
                marginRight: '5px',
                color: 'red',
                cursor: 'pointer'
              },
              on: {
                'click'() {
                  v.$router.push('/productList');
                  localStorage.setItem('seleteYmsProductCategoryId', JSON.stringify(data.ymsProductCategoryId));
                }
              }
            }, '(' + data.categoryCount + ')'),
            h('span', {
              class: 'hover-color-ccc',
              attrs: {
                title: data.productCategoryNavigation
              },
              domProps: {
                innerHTML: data.name
              },
            }, data.name)
          ]);
          return h('div', {
            class: 'tree_center_box',
            style: {
              display: data.isHide ? 'none' : 'flex'
            },
            attrs: {
              'data-sortNo': data.sortNo,
              'data-ymsProductCategoryId': data.ymsProductCategoryId,
              'data-productCategoryNavigation': data.productCategoryNavigation
            },
            domProps: {
              draggable: true
            },
            on: {
              dragstart(e) {
                v.dragConfig.isStartExpandCache = data.expand;
                if (data.children) {
                  data.expand = false;
                }
                v.dragConfig.startTarget.sortNo = data.sortNo;
                v.dragConfig.startTarget.ymsProductCategoryId = data.ymsProductCategoryId;
                v.dragConfig.startTarget.productCategoryNavigation = data.productCategoryNavigation;
              },
              dragenter(e) {
                function clearData() {
                  v.dragConfig.endTarget.sortNo = null;
                  v.dragConfig.endTarget.ymsProductCategoryId = null;
                  v.dragConfig.endTarget.productCategoryNavigation = null;
                }

                if (v.dragConfig.startTarget.productCategoryNavigation) {
                  let startDomNavigation = v.dragConfig.startTarget.productCategoryNavigation.split('->');
                  let endDomNavigation = [];
                  let targetDom = null;
                  if (!e.target.parentNode.parentNode.dataset['productcategorynavigation']) {
                    clearData();
                    return;
                  }
                  endDomNavigation = e.target.parentNode.parentNode.dataset['productcategorynavigation'].split('->');
                  targetDom = e.target.parentNode.parentNode; // 存放值dom
                  if (startDomNavigation.length === endDomNavigation.length &&
                    targetDom.dataset['ymsproductcategoryid'] !== v.dragConfig.startTarget.ymsProductCategoryId) {
                    let _isMove = true; // 是否可以移动
                    for (let i = 0; i < (startDomNavigation.length - 1); i++) {
                      if (startDomNavigation[i] !== endDomNavigation[i]) {
                        _isMove = false;
                      }
                    }
                    if (_isMove) {
                      if (targetDom.dataset['sortno'] > v.dragConfig.startTarget.sortNo) {
                        if (!targetDom.className.includes(' drag-active-b')) {
                          targetDom.className += ' drag-active-b';
                        }
                      } else {
                        if (!targetDom.className.includes(' drag-active-t')) {
                          targetDom.className += ' drag-active-t';
                        }
                      }
                      if (!targetDom.parentNode.parentNode.className.includes(' drag-hide')) {
                        targetDom.parentNode.parentNode.className += ' drag-hide';
                      }
                      v.dragConfig.endTarget.sortNo = targetDom.dataset['sortno'];
                      v.dragConfig.endTarget.ymsProductCategoryId = targetDom.dataset['ymsproductcategoryid'];
                      v.dragConfig.endTarget.productCategoryNavigation = targetDom.dataset['productcategorynavigation'];
                    } else {
                      clearData();
                    }
                  } else {
                    clearData();
                  }
                } else {
                  clearData();
                }
              },
              dragleave(e) {
                let activeDom = document.querySelectorAll('.drag-active-b');
                let activeTopDom = document.querySelectorAll('.drag-active-t');
                for (let i = 0; i < activeDom.length; i++) {
                  activeDom[i].className = activeDom[i].className.replace(' drag-active-b', '');
                }
                for (let i = 0; i < activeTopDom.length; i++) {
                  activeTopDom[i].className = activeTopDom[i].className.replace(' drag-active-t', '');
                }
              },
              dragend(e) {
                data.expand = v.dragConfig.isStartExpandCache;
                let hideDom = document.querySelectorAll('.drag-hide');
                for (let i = 0; i < hideDom.length; i++) {
                  hideDom[i].className = hideDom[i].className.replace(' drag-hide', '');
                }
                if (v.dragConfig.endTarget.ymsProductCategoryId) {
                  v.axios.put(api.put_ymsProductCategory_sort, [
                    {
                      sortNo: v.dragConfig.startTarget.sortNo,
                      ymsProductCategoryId: v.dragConfig.startTarget.ymsProductCategoryId,
                    },
                    {
                      sortNo: v.dragConfig.endTarget.sortNo,
                      ymsProductCategoryId: v.dragConfig.endTarget.ymsProductCategoryId,
                    }
                  ]).then(response => {
                    if (response.data.code === 0) {
                      v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
                      v.getList();
                    }
                  });
                } else {
                  v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003510'));
                }
              }
            }
          }, [
            ordinary,
            options
          ]);
        };
        if (v.isAlibabaSite) {
          if (v.searchTree) {
            v.$set(arr[index], 'expand', true);
          } else {
            v.$set(arr[index], 'expand', false);
          }
        } else {
          v.$set(arr[index], 'expand', true);
        }
      });
      // 处理升序、降序
      if (newArr.length > 0) {
        newArr.map((item, index) => {
          item.ascTalg = true;
          item.descTalg = true;
          if (index === 0) {
            item.ascTalg = false;
          }
          if (item.children && item.children.length > 0) {
            item.children.map((ele, idx) => {
              ele.ascTalg = true;
              ele.descTalg = true;
              if (idx === 0) {
                ele.ascTalg = false;
              }
              if (ele.children.length > 0) {
                ele.children.map((talg, ids) => {
                  talg.ascTalg = true;
                  talg.descTalg = true;
                  if (ids === 0) {
                    talg.ascTalg = false;
                  }
                });
                ele.children[ele.children.length - 1].descTalg = false;
              }
            });
            item.children[item.children.length - 1].descTalg = false;
          }
        });
        newArr[newArr.length - 1].descTalg = false;
      }
      if (value !== 'subclass') {
        v.handlerClassifiedData = newArr;
      }

      // 处理数据添加level层级标识
      function addLevel(list, level = 1) {
        if (!Array.isArray(list)) return [];
        return list.map(item => {
          item.level = level;
          if (item.children && item.children.length > 0) {
            addLevel(item.children, level + 1);
          }
          return item;
        });
      }

      return addLevel(newArr);
    },
    // 查看
    view(data) {
      let v = this;
      let talg = true;
      v.operationType = 'look';
      if (data.length === 0) {
        v.selectedProductCategory.selected = true;
        talg = false;
      } else {
        v.selectedProductCategory = data[0];
        talg = data[0].ymsProductCategoryId !== '-1';
      }
      if (talg) {
        v.selectedNode = data[0];
        v.productCategory.ymsProductCategoryId = data[0].ymsProductCategoryId;
        v.getClassifyDetails(v.productCategory.ymsProductCategoryId);
        v.viewMode = true;
        v.addClassificationTalg = false;
      } else {
        v.viewMode = false;
        v.platformList = [];
        v.platformData = [];
        v.tableData = [];
        v.originalPlatformInfoData = [];
        v.optionBtnWidth = [];
        v.commoditySpecificationsData = [];
        v.originalSpecificationsList = [];
        v.selectedNode = [];
        v.$nextTick(() => {
          v.$refs['productCategory'].resetFields();
        });
      }
    },
    // 编辑
    editBtn() {
      this.updateDetailsTalg = true;
      this.updateCategoryTalg = true;
      this.view([this.selectedProductCategory]);
      this.viewMode = true;
      this.addClassificationTalg = true;
      this.operationType = 'edit';
      this.optionBtnWidth = [];
      setTimeout(() => {
        if (this.commoditySpecificationsData.length > 0) {
          this.commoditySpecificationsData = [...this.commoditySpecificationsData];
        }
        if (this.tableData.length > 0) {
          this.tableData = [...this.tableData];
        }
      }, 500);
    },
    // 新增子分类
    addSubcategoryBtn() {
      this.$refs['productCategory'].resetFields();
      this.platformList = [
        {
          platformId: null,
          siteId: null,
          categoryName: '',
          categoryId: null,
          showTalg: true
        }
      ];
      this.tableData = [];
      this.platformData = [];
      this.customizedPartsData = [];
      this.isSupportCustomization = 0;
      this.originalSpecificationsList = [];
      this.commoditySpecificationsData = [];
      this.viewMode = true;
      this.operationType = 'add';
      this.fieldList.map((key) => {
        this.productCategory[key] = null;
      });
      this.productCategory.isShow = 1;
    },
    changeExpand(data) {
      if (data.nodeKey === 0) {
        this.showTree = data.expand;
      }
    },
    // 展开或合并树，当flag为true时全部展开，flag为false时全部合并
    exchangeTree() {
      this.showTree = !this.showTree;
      this.categoryTree = this.treeChangeExpand(this.categoryTree, this.showTree);
    },
    // 递归给树设置expand
    treeChangeExpand(treeData, flag) {
      let v = this;

      function handleData(treeData, flag) {
        for (let i = 0; i < treeData.length; i++) {
          v.$set(treeData[i], 'expand', flag);
          if (treeData[i].children) {
            treeData[i].children = v.treeChangeExpand(treeData[i].children, flag);
          }
        }
        return treeData;
      }

      if (v.isAlibabaSite) {
        if (flag) {
          for (let i = 0; i < treeData.length; i++) {
            if (treeData[i].ymsProductCategoryId === '-1') {
              v.$set(treeData[i], 'expand', flag);
            } else {
              v.$set(treeData[i], 'expand', false);
            }
            if (treeData[i].children) {
              treeData[i].children = v.treeChangeExpand(treeData[i].children, flag);
            }
          }
          return treeData;
        } else {
          return handleData(treeData, flag);
        }
      } else {
        return handleData(treeData, flag);
      }
    },
    // 移除当前平台
    removePlatformBtn(index) {
      this.platformList[index].showTalg = false;
      this.platformList.splice(index, 1);
    },
    // 新增属性
    addAttributesBtn(type) {
      this.$refs.attrModal.newAttributeTalg = true;
      this.$refs['attrModal'].initAttributesData('add', null, type);
    },
    // 校验是否有移除商品属性数据
    verificationAttribute() {
      let v = this;
      if (v.isDeleteItemAttribute) {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003276'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003277'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000555'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            v.attributeBtn(1);
          },
          onCancel: () => {
          }
        });
      } else {
        v.attributeBtn(1);
      }
    },

    // 新增、编辑分类和平台信息和物品属性的保存按钮
    attributeBtn(isPositionCheck) {
      let v = this;
      v.errorMessageContentList = [];
      let currentNode = v.selectedNode;
      let query = {};
      let method = '';
      let url = '';
      if (v.operationType === 'add') {
        url = api.post_ymsProductCategory;
        method = 'post';
        query = {
          name: v.handleMultilingualSingleParam(v.productCategory, 'name_'),
          parentId: (currentNode.ymsProductCategoryId !== '-1') ? currentNode.ymsProductCategoryId : null,
          ymsCategoryProductAttributeBos: [],
          ymsListingCategoryMappingBos: [],
          ymsSiteId: v.ymsSiteId,
          scode: v.systemEnvironment,
        };
      } else if (v.operationType === 'edit') {
        url = api.put_ymsProductCategory;
        method = 'put';
        query = {
          name: v.handleMultilingualSingleParam(v.productCategory, 'name_'),
          ymsCategoryProductAttributeBos: [],
          ymsListingCategoryMappingList: [],
          ymsProductCategoryId: v.productCategory.ymsProductCategoryId
        };
      }
      // 尺码表模板
      query.ymsProductSizeTemplateId = v.productCategory.ymsProductSizeTemplateId;
      query.isShow = v.productCategory.isShow;

      // 处理商品规格和商品属性的参数
      function commodityParameters(data, type) {
        let list = [];
        if (data.length > 0) {
          let attributeType = type === 'attribute' ? 0 : 1;
          data.map((item) => {
            let objs = {};
            objs.ymsProductAttributeTemplateId = item.ymsProductAttributeTemplateId;
            objs.ymsCategoryProductAttributeId = item.ymsCategoryProductAttributeId;
            objs.keyWordsType = item.keyWordsType;
            objs.attributeType = item.attributeType ? item.attributeType : attributeType;   // attributeType: 0 基础属性   1 规格属性
            objs.isMainAttribute = item.isMainAttribute ? 1 : 0;
            list.push(objs);
          });
          return list;
        }
      }

      // 商品属性
      let commodityAttribute = commodityParameters(v.tableData, 'attribute') || [];
      // 商品规格
      let commoditySpecifications = commodityParameters(v.commoditySpecificationsData, 'specifications') || [];
      query.ymsCategoryProductAttributeBos = [...commodityAttribute, ...commoditySpecifications];

      // 在新增、编辑时，需要校验商品规格是否设置了主属性
      if (v.commoditySpecificationsData.length > 0) {
        let talg = v.commoditySpecificationsData.some((item) => item.isMainAttribute === 1);
        if (!talg) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003511'));
          return false;
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003511'));
        return false;
      }
      if (v.platformData) {
        let _platformData = JSON.parse(JSON.stringify(v.platformData));
        query.ymsListingCategoryMappingList = _platformData.map(i => {
          i.productCategoryId = v.productCategory.ymsProductCategoryId;
          i.categoryTree = i.categoryTree || [];
          return i;
        });
      }
      // 报关信息
      query.cnHsName = v.productCategory.cnHsName;
      query.enHsName = v.productCategory.enHsName;
      query.hsCode = v.productCategory.hsCode;
      // 商品定制部位
      let insertYmsProductCategoryPositionBos = [];
      query.isSupportCustomization = v.isSupportCustomization;
      if (v.isSupportCustomization === 1) {
        v.customizedPartsData.map((k) => {
          insertYmsProductCategoryPositionBos.push({
            parts: k.parts,
            status: k.status,
            ymsProductCategoryPositionId: k.ymsProductCategoryPositionId
          });
        });
      }
      query.insertYmsProductCategoryPositionBos = insertYmsProductCategoryPositionBos;
      query.isPositionCheck = isPositionCheck;
      v.$refs['productCategory'].validate((valid, err) => {
        if (valid) {
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.editingFailurePromptModal = false;
              if (v.operationType === 'add') {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000456'));
                v.productCategory.expand = true;
                v.productCategory.ymsProductCategoryId = response.data.datas.ymsProductCategoryId;
                v.selectedProductCategory = response.data.datas;
              } else if (v.operationType === 'edit') {
                v.$set(v.selectedNode, 'name', v.productCategory['name']);
                v.selectedProductCategory.ymsProductCategoryId = v.productCategory.ymsProductCategoryId;
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000839'));
              }
              v.updateCategoryTalg = false;
              v.isDeleteItemAttribute = false;
              v.getList(v.selectedProductCategory);
            } else if (response.data.code === 1112964) {
              let errorMessage = response.data.others.errorMessage;
              if (errorMessage) {
                if (isJSON(errorMessage)) {
                  let list = JSON.parse(errorMessage);
                  if (list.length > 0) {
                    list.map((item) => {
                      v.errorMessageContentList.push(item[v.languagesVal]);
                    });
                  }
                }
                v.editingFailurePromptModal = true;
              }
            }
          });
        }
      });
    },
    // 平台信息和物品属性的取消按钮(回退到编辑之前的状态)
    resetBtn() {
      this.updateDetailsTalg = false;
      this.updateCategoryTalg = false;
      this.operationType = 'look';
      this.viewMode = true;
      this.view([this.selectedProductCategory]);
      /*this.getList(this.selectedProductCategory);*/
    },
    // 新增属性后，重新刷新列表数据
    updateData(data) {
      if (data) {
        this.$refs['attributePool'].getList(data);
      }
    },
    // 编辑时，获取站点的数据
    getSiteData(platform) {
      let v = this;
      return new Promise(resolve => {
        v.platformId = platform;
        v.axios.get(api.get_erpCommon_queryAccountSite + `${platform}` + '?time' + new Date().getTime()).then(response => {
          if (response.data.code === 0) {
            v.siteData = response.data.datas;
            resolve({
              data: response.data.datas,
              platformId: platform
            });
          }
        });
      });
    },
    // 选中对应的平台时，获取平台站点数据
    changePlatform(platform, index) {
      let v = this;
      v.platformId = platform;
      v.categoryPlatformId = platform;
      v.platformList[index].siteId = null;
      v.platformList[index].categoryName = '';
      v.platformList[index].categoryId = null;
      v.axios.get(api.get_erpCommon_queryAccountSite + `${platform}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          v.$set(v.platformList[index], 'siteData', response.data.datas);
          v.$forceUpdate();
          v.siteData = data;
        }
      });
      v.$forceUpdate();
    },
    // 选中对应的站点时
    changeSite(siteId, index, item) {
      let v = this;
      v.siteId = siteId;
      v.categoryPlatformId = item.platformId;
      v.platformList[index].categoryName = '';
      v.platformList[index].categoryId = null;
    },
    // 选择类目后获取类目的名称和id
    categorySave(data, currentIndex) {
      this.platformList.map((item, index) => {
        if (index === currentIndex) {
          item.categoryName = data.categoryName;
          item.categoryId = data.categoryId;
          item.rootCategoryId = data.rootCategoryId;
        }
      });
    },
    // 选择类目
    openChoseCategory(index, item) {
      this.currentIndex = index;
      this.categoryPlatformId = item.platformId;
      this.siteId = item.siteId;
      this.$refs.choseCategoryTalg.open('first', item.platformId, item.siteId);
    },
    // 分类排序
    classificationSort(data, type) {
      let v = this;
      let obj = {};
      if (v.handlerClassifiedData.length > 0) {
        let ymsProductCategoryId = data.ymsProductCategoryId;
        v.handlerClassifiedData.map((item, index) => {
          if (item.ymsProductCategoryId === ymsProductCategoryId) {
            if (type === 'desc') {
              obj = {
                sortNo: v.handlerClassifiedData[index + 1].sortNo,
                ymsProductCategoryId: v.handlerClassifiedData[index + 1].ymsProductCategoryId,
              };
            } else {
              obj = {
                sortNo: v.handlerClassifiedData[index - 1].sortNo,
                ymsProductCategoryId: v.handlerClassifiedData[index - 1].ymsProductCategoryId
              };
            }
          } else {
            if (item.children.length > 0) {
              item.children.map((ele, idx) => {
                if (ele.ymsProductCategoryId === ymsProductCategoryId) {
                  if (type === 'desc') {
                    obj = {
                      sortNo: item.children[idx + 1].sortNo,
                      ymsProductCategoryId: item.children[idx + 1].ymsProductCategoryId
                    };
                  } else {
                    obj = {
                      sortNo: item.children[idx - 1].sortNo,
                      ymsProductCategoryId: item.children[idx - 1].ymsProductCategoryId
                    };
                  }
                } else {
                  if (ele.children.length > 0) {
                    ele.children.map((talg, ids) => {
                      if (talg.ymsProductCategoryId === ymsProductCategoryId) {
                        if (type === 'desc') {
                          obj = {
                            sortNo: ele.children[ids + 1].sortNo,
                            ymsProductCategoryId: ele.children[ids + 1].ymsProductCategoryId
                          };
                        } else {
                          obj = {
                            sortNo: ele.children[ids - 1].sortNo,
                            ymsProductCategoryId: ele.children[ids - 1].ymsProductCategoryId
                          };
                        }
                      }
                    });
                  }
                }
              });
            }
          }
        });
        if (Object.keys(obj).length > 0) {
          let query = [
            {
              sortNo: data.sortNo,
              ymsProductCategoryId: data.ymsProductCategoryId
            }
          ];
          query.push(obj);
          v.axios.put(api.put_ymsProductCategory_sort, query).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
              v.getList();
            }
          });
        }
      }
    },
    // 删除分类
    deleteClassification(ymsProductCategoryId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003512'),
        onOk: () => {
          v.axios.delete(api.delete_ymsProductCategory + ymsProductCategoryId).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
              v.getList();
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 获取尺码模板的基础数据
    getProductSizeTemplateData() {
      let v = this;
      v.axios.get(api.get_ymsProductSizeTemplate_query).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          v.ymsProductSizeValueList = response.data.datas;
        }
      });
    },
    // 设置主属性
    setMainAttr(data) {
      let v = this;
      v.commoditySpecificationsData.forEach((i, index) => {
        v.$set(v.commoditySpecificationsData[index], 'isMainAttribute', 0);
        if (i.ymsProductAttributeTemplateId === data.ymsProductAttributeTemplateId) {
          v.$set(v.commoditySpecificationsData[index], 'isMainAttribute', 1);
        }
      });
    },
    // 分类名称的校验
    cnameValidator(val) {
      return (rule, value, callback) => {
        if (value) {
          if (value.indexOf('->') > -1) { // 不能包含->特殊字符
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003513')));
          } else {
            callback();
          }
        } else {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003442') + val + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002427')));
        }
      };
    },
    // 设置表单必填项校验规则
    getRules(item) {
      let v = this;
      let list = [];
      if (item.required) {
        list = [
          {required: true, validator: v.cnameValidator(item.title), trigger: 'blur'}
        ];
      }
      return list;
    },
    // 更新商品属性列表数据
    updateAttributeTableData(data) {
      this.tableData = data;
    },
    // 更新商品规格列表数据
    updateSpecificationsTableData(data) {
      this.commoditySpecificationsData = data;
    },
    // 启用停用刊登映射平台
    enableDeactivateBtn(status, ymsListingCategoryMappingId) {
      let url = '';
      let text = '';
      if (status === 1) {
        url = api.post_ymsListingCategoryMapping_disable + ymsListingCategoryMappingId;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002486');
      } else {
        url = api.post_ymsListingCategoryMapping_enable + ymsListingCategoryMappingId;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002485');
      }
      this.axios.post(url, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
        if (res.data.code === 0) {
          this.$Message.success(text);
          this.getClassifyDetails(this.productCategory.ymsProductCategoryId);
        }
      });
    },
    // 切换分类站点
    changeClassificationSite(value) {
      this.searchTree = '';
      this.showTree = true;
      this.categoryTree[0].children = [];
      this.ymsSiteList.map((item) => {
        if (value === item.ymsSiteId) {
          this.merchantType = item.merchantType;
        }
      });
      this.initData('change');
    },
    // 异步请求阿里国际分销的子类目数据
    loadCategoryData(item, callback) {
      let v = this;
      let ymsProductCategoryId = item.ymsProductCategoryId;
      if (ymsProductCategoryId) {
        v.axios.get(api.get_ymsProductCategory_querySubCategorysById + ymsProductCategoryId).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              data.map((ele) => {
                ele.loading = false;
                ele.children = [];
                ele.categoryCount = 0;
                v.productCountData.map(talg => {
                  if (ele.ymsProductCategoryId === talg.ymsProductCategoryId) {
                    ele.categoryCount = talg.productCount;
                  }
                });
              });
              let newList = v.toTree(data, 'productCategoryNavigation', '->', null, 'subclass');
              callback(newList);
            } else {
              item.loading = false;
              delete item.loading;
            }
          }
        });
      } else {
        console.log('=======当前类目无分类id======');
      }
    },
    // 上传文件成功
    uploadSuccess(response, file, fileList) {
      if (response.code === 0) {
        let taskNumber = response.datas;
        if (taskNumber) {
          setTimeout(() => {
            pageJump('/yms.html#/importTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
          }, 30);
        }
      }
    },
    // 上传文件失败
    uploadError() {
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000250'));
      return false;
    },
    // 上传文件格式异常
    handleFormatError() {
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003514'));
      return false;
    },
    // 切换商品定制部位设置
    customizedPartsChange(value) {
      let v = this;
      if (v.isSupportCustomization !== value) {
        if (value === 0) {
          verifyCategoryCustomizedProducts(v.productCategory.ymsProductCategoryId).then((vals) => {
            if (vals) {
              v.isSupportCustomization = 1;
              v.$Modal.warning({
                title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
                content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003515'),
                okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316'),
                onOk: () => {
                  v.isSupportCustomization = 1;
                }
              });
            } else {
              v.isSupportCustomization = value;
            }
          });
        } else {
          v.isSupportCustomization = value;
        }
      }
    },
    // 手动更新商品定制部位的数据
    updateCustomizedParts(data) {
      let {customizedPartsType, currentIndex, ...obj} = data;
      if (customizedPartsType === 'add') {
        this.customizedPartsData.push(obj);
      } else {
        this.customizedPartsData.map((item, index) => {
          if (index === currentIndex) {
            item.parts = obj.parts;
            item.status = obj.status;
          }
        });
        this.$forceUpdate();
      }
    },
    // 保存更新分类信息内容之后，自动让滚动条滚动到当前选中分类的位置
    scrollToSelectedNode() {
      this.$nextTick(() => {
        const container = this.$refs.treeScrollBox;
        const selectedNode = container.querySelector('.ivu-tree-title-selected');
        if (!container || !selectedNode) return;
        const containerRect = container.getBoundingClientRect();
        const nodeRect = selectedNode.getBoundingClientRect();
        container.scrollTop += nodeRect.top - containerRect.top - container.clientHeight / 2;
      });
    }
  },
  watch: {
    // 监听商品规格列表
    commoditySpecificationsData: {
      handler(data) {
        if (data.length > 0) {
          this.isSizeAttribute = data.some((item) => {
            return item.isSizeAttribute === 1;
          });
        }
      },
      deep: true
    }
  },
  components: {
    languagesTabs,
    PlatformModal,
    addAttributes,
    choseCategory,
    mappingAttr,
    attributePoolModal,
    customizedPartsModal
  }
};
</script>

<style>
.mappingForm .ivu-form-item {
  margin-bottom: 0;
}

.drag-active-b {
  border-bottom: 2px solid #00a0e9;
}

.drag-active-t {
  border-top: 2px solid #00a0e9;
}

.drag-hide .ivu-tree-children {
  display: none;
}

.drag-dom {
  border: 1px solid #00a0e9;
}

.drag-disabled {
  cursor: not-allowed;
}

.platform-del {
  cursor: pointer;
  color: red;
}

.platform-del:hover {
  opacity: 0.9;
}

.platform-edit {
  color: #1890FF;
  cursor: pointer;
}

.platform-edit:hover {
  opacity: 0.9;
}
</style>
<style lang="less" scoped>
.pos-rel {
  position: relative;
}

.table-icon:hover {
  opacity: 0.9;
}

.container_box {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;

  .opts_box {
    display: flex;
    align-items: center;
    position: absolute;
    top: -45px;
    right: 20px;
    z-index: 1000;
  }

  .tree_box {
    min-width: 350px;
    width: 22%;
    margin-right: 15px;

    .site_box {
      width: 100%;
      padding: 0 20px;
      height: 46px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      background-color: #fff;
      box-sizing: border-box;
    }

    .tree_conter {
      background-color: #fff;
      width: 100%;
      max-height: 700px;
      overflow-y: auto;
      overflow-x: hidden;
      box-sizing: border-box;

      .all_style {
        width: 100%;
        cursor: pointer;
        color: #2D8CF0;
        background-color: #fff;
        position: sticky;
        left: 0;
        top: 0;
        height: 42px;
        line-height: 42px;
        box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.08);
        padding: 0 15px;
        z-index: 100;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      /deep/ .ivu-tree {
        .ivu-tree-title {
          width: 100%;
          box-sizing: border-box;
        }

        .tree_center_box {
          display: flex;
          align-items: center;
          padding-right: 15px;
          justify-content: space-between;

          .hover-color-ccc {
            display: inline-block;
            max-width: 135px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-wrap: break-word;
            word-break: break-all;
          }
        }
      }

      .suspension_box {
        position: sticky;
        left: 0;
        top: 0;
        width: 360px;
        height: 40px;
        line-height: 40px;
        z-index: 998;
        background-color: #fff;
        box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.08);
        padding: 0 15px;
        color: #333;
        font-size: 15px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-wrap: break-word;
        word-break: break-all;
      }

      /deep/ .ivu-tooltip-rel {
        display: flex;
      }

      /deep/ .ivu-tree-title {
        .option_icon_style {
          font-size: 20px;
          cursor: pointer;
          margin-left: 6px;
        }

        .arrow-down {
          color: #34C308;
        }

        .arrow-up {
          color: #D9230B;
        }
      }
    }

    .category_opts_box {
      display: flex;
      width: 100%;
      justify-content: space-between;
      border: 1px solid #ccc;
      box-sizing: border-box;

      .cattegory_btn_style {
        padding: 0;
        margin: 0;
        border: none;
        flex: 1;
        height: 45px;
        line-height: 45px;
        border-radius: 0;
        width: 100%;

        .edit_box, .add_box {
          display: flex;

          .iconfont {
            font-size: 20px;
          }

          .text_style {
            margin-left: 8px;
            font-size: 14px;
          }
        }
      }

      /deep/ .ivu-upload {
        width: 100%;
      }

      .line_styles {
        display: inline-block;
        width: 2px;
        height: 45px;
        line-height: 45px;
        background-color: #CCCCCC;
      }

    }

    /deep/ .ivu-tree {
      .keywords_highlight {
        display: inline-block;
        color: #1890FF;
        background-color: transparent !important;
      }
    }
  }

  .platform_content {
    width: 78%;
    max-height: 757px;
    overflow-y: auto;

    .platform_box {
      width: 100%;
      //max-height: 300px;
      //overflow-x: hidden;
      //overflow-y: auto;

      .remove_icon {
        font-size: 24px;
        cursor: pointer;
        color: #808695;
        margin-left: 8px;
      }

      /deep/ .ivu-table-wrapper {
        overflow: initial !important;

        .ivu-table {
          overflow: initial !important;

          .ivu-table-cell {
            overflow: initial !important;
          }
        }
      }

      /deep/ .reset_tooltip_style {
        position: relative !important;

        .ivu-poptip-popper {
          position: absolute;
          top: -108px !important;
          left: -170px !important;
          width: 210px;
        }
      }
    }
  }

  .customizedParts_set_box {
    position: relative;

    .customizedParts_set_item {
      position: absolute;
      height: 100%;
      top: 0;
      z-index: 10;
      cursor: pointer;
      margin: 0;
    }

    .customizedParts_deny {
      width: 50%;
      left: 0;
    }

    .customizedParts_correct {
      width: 50%;
      right: 0;
    }
  }
}

</style>
